import fileToBase64 from "./fileToBase64";

type PreparedFile = {
  fileName: string;
  base64File?: string;
};

export async function prepareSingleFile(
  fileList?: any[]
): Promise<PreparedFile | undefined> {
  if (!fileList?.length) return undefined;

  const file = fileList[0];

  if (file.uid === "0") {
    return { fileName: file.name };
  }

  if (file.originFileObj) {
    const base64File = await fileToBase64(file.originFileObj);
    return { fileName: file.name, base64File };
  }

  return undefined;
}

export async function prepareMultipleFiles(
  fileList?: any[]
): Promise<PreparedFile[] | undefined> {
  if (!fileList?.length) return undefined;

  const result: PreparedFile[] = [];

  for (const file of fileList) {
    if (file.uid.startsWith("existing-")) {
      result.push({ fileName: file.name });
    } else if (file.originFileObj) {
      const base64File = await fileToBase64(file.originFileObj);
      result.push({ fileName: file.name, base64File });
    }
  }

  return result.length ? result : undefined;
}